export const office = [
  { char: '💻', name: 'Laptop', nameZh: '筆記型電腦', keywords: ['pc', 'work', '筆電'] },
  { char: '🖥️', name: 'Desktop', nameZh: '桌上型電腦', keywords: ['pc', 'work', '電腦'] },
  { char: '🖨️', name: 'Printer', nameZh: '印表機', keywords: ['office', 'paper', '列印'] },
  { char: '⌨️', name: 'Keyboard', nameZh: '鍵盤', keywords: ['type', 'pc', '鍵盤'] },
  { char: '🖱️', name: 'Mouse', nameZh: '滑鼠', keywords: ['pc', 'click', '滑鼠'] },
  { char: '💽', name: 'Disk', nameZh: '光碟', keywords: ['save', 'data', '光碟'] },
  { char: '💾', name: 'Floppy', nameZh: '磁片', keywords: ['save', 'old', '磁片'] },
  { char: '💿', name: 'CD', nameZh: '唱片', keywords: ['music', 'data', '唱片'] },
  { char: '📱', name: 'Mobile', nameZh: '手機', keywords: ['phone', 'cell', '手機'] },
  { char: '☎️', name: 'Telephone', nameZh: '電話', keywords: ['call', 'old', '電話'] },
  { char: '📞', name: 'Receiver', nameZh: '聽筒', keywords: ['call', 'phone', '聽筒'] },
  { char: '📟', name: 'Pager', nameZh: '呼叫器', keywords: ['old', 'call', '呼叫器'] },
  { char: '📠', name: 'Fax', nameZh: '傳真機', keywords: ['office', 'paper', '傳真'] },
  { char: '🔋', name: 'Battery', nameZh: '電池', keywords: ['power', 'energy', '電池'] },
  { char: '🔌', name: 'Plug', nameZh: '插頭', keywords: ['power', 'electric', '插頭'] },
  { char: '💡', name: 'Bulb', nameZh: '燈泡', keywords: ['idea', 'light', '燈泡'] },
  { char: '🔦', name: 'Flashlight', nameZh: '手電筒', keywords: ['light', 'dark', '手電筒'] },
  { char: '🕯️', name: 'Candle', nameZh: '蠟燭', keywords: ['light', 'fire', '蠟燭'] },
  { char: '🗑️', name: 'Trash', nameZh: '垃圾桶', keywords: ['bin', 'clean', '垃圾桶'] },
  { char: '🛢️', name: 'Oil Drum', nameZh: '油桶', keywords: ['gas', 'fuel', '油桶'] },
  { char: '💸', name: 'Flying Money', nameZh: '飛錢', keywords: ['spend', 'money', '飛錢'] },
  { char: '💵', name: 'Dollar', nameZh: '美金', keywords: ['money', 'cash', '美金'] },
  { char: '💰', name: 'Money Bag', nameZh: '錢袋', keywords: ['rich', 'money', '錢袋'] },
  { char: '💳', name: 'Credit Card', nameZh: '信用卡', keywords: ['pay', 'buy', '信用卡'] },
  { char: '💎', name: 'Gem', nameZh: '寶石', keywords: ['rich', 'diamond', '寶石'] },
  { char: '⚖️', name: 'Balance Scale', nameZh: '天平', keywords: ['law', 'justice', '公平'] },
  { char: '🔧', name: 'Wrench', nameZh: '扳手', keywords: ['tool', 'fix', '扳手'] },
  { char: '🔨', name: 'Hammer', nameZh: '槌子', keywords: ['tool', 'build', '槌子'] },
  { char: '⚒️', name: 'Hammer and Pick', nameZh: '槌子與鎬', keywords: ['tool', 'work', '工具'] },
  { char: '🛠️', name: 'Hammer and Wrench', nameZh: '工程工具', keywords: ['tool', 'fix', '工程'] },
  { char: '⛏️', name: 'Pick', nameZh: '十字鎬', keywords: ['tool', 'mine', '十字鎬'] },
  { char: '⚙️', name: 'Gear', nameZh: '齒輪', keywords: ['setting', 'machine', '設定'] },
  { char: '🧱', name: 'Brick', nameZh: '磚塊', keywords: ['build', 'wall', '磚塊'] },
  { char: '⛓️', name: 'Chains', nameZh: '鍊條', keywords: ['lock', 'metal', '鍊條'] },
  { char: '🪚', name: 'Saw', nameZh: '鋸子', keywords: ['tool', 'wood', '鋸子'] },
  { char: '🔫', name: 'Water Gun', nameZh: '水槍', keywords: ['toy', 'shoot', '水槍'] },
  { char: '💣', name: 'Bomb', nameZh: '炸彈', keywords: ['boom', 'explode', '炸彈'] },
  { char: '🛡️', name: 'Shield', nameZh: '盾牌', keywords: ['protect', 'safe', '盾牌'] },
];